import type { Appearance } from "@clerk/types";
import { dark } from "@clerk/themes";

// Clerk ships official `dark` and default-light baseThemes. We layer
// brand tweaks (font, accent, radius) on top via `variables`. Element
// className overrides are kept minimal — only places where the brand
// look diverges from Clerk's default.
//
// Per-element CSS hacks live in `styles/globals.css` only when Clerk's
// theming primitives don't expose a hook for that surface.

type ThemeName = "dark" | "light";

const fontStack =
  "Geist, -apple-system, BlinkMacSystemFont, 'Segoe UI', " +
  "system-ui, sans-serif";

const sharedVariables = {
  fontFamily: fontStack,
  fontFamilyButtons: fontStack,
  fontSize: "14px",
  borderRadius: "4px", // --radius-2
  colorDanger: "#b8332a",
  colorSuccess: "#1f7a6b",
  colorWarning: "#b8801a",
};

export function clerkAppearanceFor(theme: ThemeName): Appearance {
  return {
    baseTheme: theme === "dark" ? dark : undefined,
    variables: sharedVariables,
    layout: {
      socialButtonsVariant: "iconButton",
      shimmer: false,
      logoPlacement: "inside",
    },
  };
}

